class RankingDebugController {
  constructor(UserService) {
    this.user = UserService.user;
    this.isExpanded = false;
  }

  shouldShow() {
    return this.user.admin && this.list && this.list.ranking_debug;
  }

  toggleDebug() {
    this.isExpanded = !this.isExpanded;
  }

  formatDate(dateString, ago = false) {
    if (!dateString) return 'Never';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    
    // Format: DD/MM/YYYY HH:MM (relative)
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const timeStr = `${day}/${month}/${year} ${hours}:${minutes}`;

    if (!ago) {
      return timeStr;
    }

    if (diffMins < 1) return `${timeStr} (now)`;
    if (diffMins < 60) return `${timeStr} (${diffMins}m ago)`;
    if (diffHours < 24) return `${timeStr} (${diffHours}h ago)`;
    if (diffDays < 7) return `${timeStr} (${diffDays}d ago)`;
    return timeStr;
  }
}

RankingDebugController.$inject = ['UserService'];

export const rankingDebug = {
  bindings: {
    list: '<'
  },
  controller: RankingDebugController,
  template: require('./rankingDebug.html')
};

